module.exports = __webpack_public_path__ + "static/media/playlist-icon-white.97218be9.svg";